import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AlertComponent } from './components/alert/alert.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CardComponent } from './components/card/card.component';
import { ApexChartComponent } from './components/chart/apex-chart/apex-chart.component';
import { ModalModule } from './components/modal/modal.module';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TodoCardCompleteDirective } from './directive/todo-card-complete.directive';
import { TodoListRemoveDirective } from './directive/todo-list-remove.directive';

import {
  NgbAccordionModule,
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbModule,
  NgbNavModule,
  NgbProgressbarModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';

const bootstrap = [
  NgbDropdownModule,
  NgbNavModule,
  NgbTooltipModule,
  NgbModule,
  NgbAccordionModule,
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbProgressbarModule,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CardComponent,
    BreadcrumbComponent,
    ModalModule,
    NgScrollbarModule,
    AlertComponent,
    bootstrap,
    NgClickOutsideDirective,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CardComponent,
    BreadcrumbComponent,
    ModalModule,
    TodoListRemoveDirective,
    TodoCardCompleteDirective,
    SpinnerComponent,
    NgScrollbarModule,
    AlertComponent,
    bootstrap,
    NgClickOutsideDirective,
    ApexChartComponent,
  ],
  declarations: [TodoListRemoveDirective, TodoCardCompleteDirective, SpinnerComponent, ApexChartComponent],
})
export class SharedModule {}
